/**
 * Merge SCAPI Shopper Products `inventoryIds` into Commerce SDK hook options (IM-004).
 *
 * @param {object} [options] Arguments passed to useProduct / useProducts from @salesforce/commerce-sdk-react
 * @param {string|undefined} inventoryIds - Formatted id string from warehouse cookie + preference gate
 * @returns {object|undefined}
 */
export function mergeCommerceSdkProductOptionsWithInventoryIds(options, inventoryIds) {
  if (!inventoryIds) {
    return options;
  }

  const base = options ?? {};
  const parameters = base.parameters ?? {};

  if (parameters.inventoryIds != null && parameters.inventoryIds !== '') {
    return base;
  }

  return {
    ...base,
    parameters: {
      ...parameters,
      inventoryIds,
    },
  };
}
